import './Menu.css'
import React, { useState } from 'react'
import Sidebar from '../../Components/SideBar/index'
import ScrollToTop from '../../Components/ScrollToTop'
import Index2 from '../../Components/Navbar2/index2'
import Footer from '../../Components/Footer/Footer'
import InfoSection3 from '../../Components/Infosection3/Index3'
import { homeObjOne3 } from '../../Components/Infosection3/Data3'

const MenuLeb = () => {
  const [isOpen, setIsOpen] = useState(false)
            
    const toggle = () => {
    setIsOpen(!isOpen)
    }
  return (
    <>
      <ScrollToTop />
      <div className='HeroContainer_menu'>
        <Sidebar isOpen={isOpen} toggle={toggle}/>
        <div className='Hero_menu'>
          <Index2 toggle={toggle}/>
        </div>
      </div>
      <InfoSection3 {...homeObjOne3}/>
      <div className='menu_con'>
        <div className='menu_title'>
          Vår Meny
        </div>
        <div className='pris'>
          För mer info kontakta gärna 
          <br />
          076 413 08 53
          <br />
          cateringbyprestig@gmail.com
        </div>
      </div>
      <br />
      <br /><br />
      <div className='menu'>
        <div className='menu_pic'>
          <div className='grid-container'>
            <div className='card_con'>
                <div className='wrapper'>
                <br /><br />
                    <div className='card_area'>
                        <div className='card'>
                        <div className='meny_title'>
                            LYXIGA KALLA MEZE
                        </div><br /><br />
                        <div className='menu_mat'>
                            Hummus Bil Tahini – krämig kikärtsröra med tahini, citron & extra virgin olivolja.
                            <br /><br />
                            Hummus Beiruti – hummus med persilja, chili & färska örter.
                            <br /><br />
                            Baba Ghanoush – grillad aubergine med tahini, citron & vitlök.
                            <br /><br />
                            Muhammara – rostad paprika, valnötter & granatäpple.
                            <br /><br />
                            Labneh med olivolja, mynta & za’atar.
                            <br /><br />
                            Warak Enab – vinblad fyllda med ris, örter & citron.
                            <br /><br />
                            Fattoush med krispigt libanesiskt bröd & granatäppelsirap.
                            <br /><br />
                            Tabbouleh med persilja, mynta, tomat & citron.
                            <br /><br />
                            Batata Harra – kryddig potatis med koriander, vitlök & chili.
                            <br /><br />
                            Libanesiska oliver & pickles
                            Färska örter, citron & granatäpplekärnor.
                        </div>
                        </div>
                        <div className='card'>
                        <div className='meny_title'>
                             LIBANESISKA SMAKBITAR
                      </div><br /><br />
                      <div className='menu_mat'>
                        Ostrullar – krispiga filodegsrullar fyllda med libanesisk ost & örter.
                        <br /><br />
                        Spenatpiroger – filodeg fylld med spenat, lök, citron & kryddor.
                        <br /><br />
                        Köttfärspiroger – små libanesiska piroger fyllda med kryddad nötfärs, lök & örter.
                        <br /><br />
                        Kibbe – gyllene bulgurkroketter fyllda med kryddad nötfärs, lök & pinjenötter.
                        <br /><br />
                        Friterade räkor med krispig panering & chilimajonnäs
                      </div> 
                    </div>              
                    <div className='card'>
                        <div className='meny_title'>
                        PRESTIGE GRILL – HUVUDNUMRET
                        </div><br /><br />
                    <div className='menu_mat'>
                        Kafta Meshwi -

                        Saftiga köttfärsspett med nötfärs, persilja, lök och libanesiska kryddor.
                        <br /><br />

                        Lamb Racks -

                        Grillade lammracks marinerade med vitlök, citron, rosmarin och libanesiska kryddor.
                        <br /><br />

                        Shish Tawook - 

                        Marinerade kycklingspett med vitlök, citron, yoghurt och libanesiska kryddor.
                        <br /><br />

                        Serveras med:
                        <br /><br />
                        Grillade tomater,
                        Grillad paprika,
                        Grillad lök,
                        Toum – libanesisk vitlökskräm,
                        Taratorsås,
                        Libanesisk chilisås
                    </div>
                    </div>
                    <div className='card'>
                    <div className='meny_title'>
                        LIBANESISKA VARMA SPECIALITETER
                        </div><br /><br />
                        <div className='menu_mat'>
                            Riz Bil Sha’riyah – libanesiskt ris med rostad vermicelli
                            Saffransris med mandel & rostade nötter
                            Ugnsrostad potatis med vitlök & koriander
                            Grillade säsongsgrönsaker.
                        </div>
                        </div>
                        <div className='card'>
                        <div className='meny_title'>
                             EXTRA LYXIGA TILLBEHÖR
                        </div><br /><br />
                        <div className='menu_mat'>
                           Tempura-halloumi med honung & rostade valnötter.
                           <br /><br />
                            Fetaost med olivolja & za’atar.
                            <br /><br />
                            Rostade mandlar & pinjenötter.
                        </div>
                        </div>
                        <div className='card'>
                            <div className='meny_title'>
                                LIBANESISKT BRÖD
                            </div><br /><br />
                        <div className='menu_mat'>
                            Färskt libanesiskt pitabröd.
                            <br />
                            Libanesiskt tunnbröd.
                        </div>
                        </div>
                        <div className='card'>
                            <div className='meny_title'>
                                LIBANESISKA DESSERTER
                            </div><br /><br />
                            <div className='menu_mat'>
                                Baklava med pistage & valnöt.
                                <br /><br />
                                Maamoul med dadlar & pistage.
                                <br /><br />
                                Knafeh med ost, apelsinblomsvatten & pistage.
                                <br /><br />
                                Mhalayeh – libanesisk mjölkpudding med pistage.
                                <br /><br />
                                Färska dadlar & säsongens frukt.
                                <br /><br />
                            </div>
                        </div>
                  </div>             
                </div>
              </div>
            </div>
          </div>
        </div>
      <Footer />
    </>
  )
}

export default MenuLeb